<div class="container">
  <div class="offset-3 col-8">
    <p>You have cancelled your registration for the {{ (event ? event.name : '...') }}.</p>
    <p>However, it is always time to change your mind and start over the registration process.</p>
    @if (event?.url) {
    <p>For updates on programme and speakers, please visit <a href="{{event!.url!}}">the event
        website.</a></p>
    }
    <p>Should you have any additional requests, do not hesitate to contact the <a
        href="mailto:{{contactEmail}}">Event Manager.</a></p>

    <p>Looking forward to seeing you in {{event ? event.shortLocation : '...' }}!</p>
  </div>
</div>